var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "#FFDF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40451 10.9376C9.68651 11.398 10.0534 11.7364 10.7023 11.7364C11.2474 11.7364 11.5956 11.464 11.5956 11.0875C11.5956 10.6364 11.2379 10.4767 10.6379 10.2142L10.309 10.0731C9.35961 9.66865 8.72896 9.16198 8.72896 8.09087C8.72896 7.10419 9.48075 6.35309 10.6556 6.35309C11.4921 6.35309 12.0934 6.64419 12.5267 7.40642L11.5023 8.06421C11.2767 7.65976 11.0334 7.50043 10.6556 7.50043C10.2703 7.50043 10.0261 7.74489 10.0261 8.06421C10.0261 8.45889 10.2705 8.61865 10.8349 8.86311L11.1638 9.00398C12.2816 9.48332 12.9127 9.97198 12.9127 11.0707C12.9127 12.2551 11.9823 12.904 10.7327 12.904C9.51094 12.904 8.7216 12.3218 8.33537 11.5587L9.40451 10.9376ZM4.75717 11.0516C4.96383 11.4182 5.15185 11.7282 5.60384 11.7282C6.03606 11.7282 6.30874 11.5591 6.30874 10.9016V6.42823H7.6243V10.9193C7.6243 12.2815 6.82564 12.9016 5.65984 12.9016C4.60651 12.9016 3.99652 12.3564 3.68628 11.6999L4.75717 11.0516Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.f2c47baf.svg";
export { ForwardRef as ReactComponent };